<!-- Body -->
<div class="page-container" [class.loading]="isLoading">
    <app-documents-company-document-show-header
        [allTags]="allTags"
        [backRoute]="'/documents-v2/center'"
        [companyDocument]="companyDocument"
        [initialDocumentTags]="initialDocumentTags"
        [showTemplateEditButton]="true"
        [showMeatballMenu]="true"
        (isLoading)="isLoading = $event"
        (reload)="reResolve()"
    >
    </app-documents-company-document-show-header>

    <div class="file-wrapper">
        <app-file-viewer *ngIf="!isLoading" [file]="companyDocument.file"></app-file-viewer>
    </div>
</div>
